export default __webpack_public_path__ + "static/media/eyeOff.1031a2d2.svg";